
import './App.css';
import React from "react";
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "./components/pages/Home";
import Login from './components/pages/Login';

import ProtectedRoute from "./components/pages/ProtectedRouter";

import UserAuthContextProvider from './contexts/UserAuthContext';
import UserDashboard from './components/pages/UserDashboard';
import Signup from './components/pages/Signup';



function App() {
  return (
     <Router>
      <UserAuthContextProvider>
     
    <div>
  
     
      
      <Routes>
 
     
      <Route axact path="/" element={<Home/>}/>
      <Route axact path="/Login" element={<Login/>}/>
      <Route axact path="/Signup" element={<Signup/>}/>
         <Route axact path="/UserDashboard/:userId" element={<ProtectedRoute> <UserDashboard /> </ProtectedRoute>} />
          </Routes>
    
  
    </div>
   
  </UserAuthContextProvider>
    </Router>
  );
}

export default App;
